








































































































































































































































































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import chatModule from "@/store/modules/chat-module";
import { ChatIaConfigDto } from "@/shared/dtos/chat/chat-ia-config.dto";
import { ChatMensajeDto } from "@/shared/dtos/chat/chat-mensaje.dto";
import { ChatPromptDto } from "@/shared/dtos/chat/chat-prompt.dto";
import { renderMarkdown } from "@/shared/utils/markdown";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Component
export default class IASuite extends Vue {
  public tabActivo: string = "chat";
  public mensajeActual: string = "";
  public mostrarApiKey: boolean = false;
  public guardando: boolean = false;
  public probando: boolean = false;
  public mensajePrueba: string = "";
  public tipoPrueba: string = "success";
  public dialogEliminar: boolean = false;
  public idEliminar: number = 0;
  public dialogPrompt: boolean = false;
  public promptForm: ChatPromptDto = new ChatPromptDto();
  public idEliminarPrompt: number = 0;

  public configForm: ChatIaConfigDto = new ChatIaConfigDto();

  public dialogVaciar: boolean = false;

  public tabs = [
    { id: "chat",      label: "Chat",              icon: "💬" },
    { id: "historial", label: "Conversaciones",    icon: "🕓" },
    { id: "mcps",      label: "Herramientas",      icon: "🔧" },
    { id: "prompts",   label: "Prompts",           icon: "🧠" },
    { id: "memoria",       label: "Memoria",           icon: "🔮" },
    { id: "departamentos", label: "Departamentos",     icon: "🏢" },
    { id: "config",        label: "Configuración API", icon: "⚙️" },
  ];

  public get conversaciones() { return chatModule.conversaciones; }
  public get mensajes()        { return chatModule.mensajes; }
  public get mcps()            { return chatModule.mcps; }
  public get prompts()         { return chatModule.prompts; }
  public get memorias()        { return chatModule.memorias; }
  public get departamentos()   { return chatModule.departamentos; }
  public get enviando()        { return chatModule.enviando; }
  public get conversacionActualId() { return chatModule.conversacionActualId; }
  public get ultimaRespuesta() { return chatModule.ultimaRespuesta; }
  public get proveedor()       { return chatModule.proveedor; }

  public setProveedor(p: string) {
    chatModule.setProveedor(p);
  }

  public async created() {
    await Promise.all([
      chatModule.getConversaciones(),
      chatModule.getMcps(),
      chatModule.getConfig(),
      chatModule.getPrompts(),
      chatModule.getMemorias(),
      chatModule.getDepartamentos(),
    ]);
    this.configForm = new ChatIaConfigDto(chatModule.config);
  }

  public renderMd(text: string): string {
    return renderMarkdown(text);
  }

  public formatFecha(fecha: string): string {
    if (!fecha) { return ""; }
    const d = new Date(fecha);
    if (isNaN(d.getTime()) || d.getFullYear() < 2000) { return "—"; }
    return d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "2-digit" }) +
      " " + d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  }

  public nuevaConversacion() {
    chatModule.nuevaConversacion();
  }

  public async seleccionarConversacion(id: number) {
    chatModule.setConversacionActual(id);
    await chatModule.getMensajes(id);
    this.scrollAbajo();
  }

  public async enviar() {
    const texto = this.mensajeActual.trim();
    if (!texto) { return; }
    this.mensajeActual = "";
    this.resetTextarea();

    chatModule.addMensajeLocal(new ChatMensajeDto({
      id: Date.now(),
      id_conversacion: chatModule.conversacionActualId,
      rol: "user",
      contenido: texto,
    }));
    this.scrollAbajo();

    if (chatModule.proveedor === "xiaozhi") {
      await chatModule.enviarMensajeXiaoZhi({
        conversacionId: chatModule.conversacionActualId,
        mensaje: texto,
      });
      const resp = chatModule.ultimaRespuesta.respuesta;
      if (resp) {
        chatModule.addMensajeLocal(new ChatMensajeDto({
          id: Date.now() + 1,
          id_conversacion: 0,
          rol: "assistant",
          contenido: resp,
        }));
      }
    } else {
      await chatModule.enviarMensaje({
        conversacionId: chatModule.conversacionActualId,
        mensaje: texto,
      });
      const convId = chatModule.ultimaRespuesta.conversacionId || chatModule.conversacionActualId;
      if (convId > 0) {
        chatModule.setConversacionActual(convId);
        await chatModule.getMensajes(convId);
        await chatModule.getConversaciones();
      }
    }
    this.scrollAbajo();
  }

  public scrollAbajo() {
    this.$nextTick(() => {
      const el = this.$refs.mensajesArea as HTMLElement;
      if (el) { el.scrollTop = el.scrollHeight; }
    });
  }

  public autoResize() {
    const ta = this.$refs.textarea as HTMLTextAreaElement;
    if (!ta) { return; }
    ta.style.height = "auto";
    ta.style.height = Math.min(ta.scrollHeight, 120) + "px";
  }

  public resetTextarea() {
    const ta = this.$refs.textarea as HTMLTextAreaElement;
    if (ta) { ta.style.height = "auto"; }
  }

  public irAChat(id: number) {
    this.tabActivo = "chat";
    this.seleccionarConversacion(id);
  }

  public confirmarEliminar(id: number) {
    this.idEliminar = id;
    this.dialogEliminar = true;
  }

  public async eliminarConversacion() {
    this.dialogEliminar = false;
    await chatModule.eliminarConversacion(this.idEliminar);
    this.idEliminar = 0;
  }

  public async toggleMcp(nombre: string) {
    await chatModule.toggleMcp(nombre);
  }

  public async togglePrompt(id: number) {
    await chatModule.togglePrompt(id);
  }

  public abrirNuevoPrompt() {
    this.promptForm = new ChatPromptDto();
    this.dialogPrompt = true;
  }

  public abrirEditarPrompt(p: ChatPromptDto) {
    this.promptForm = new ChatPromptDto(p);
    this.dialogPrompt = true;
  }

  public async guardarPrompt() {
    if (!this.promptForm.nombre.trim() || !this.promptForm.contenido.trim()) { return; }
    await chatModule.guardarPrompt(this.promptForm);
    this.dialogPrompt = false;
  }

  public confirmarEliminarPrompt(id: number) {
    this.idEliminarPrompt = id;
    this.dialogPrompt = false;
    setTimeout(() => this.eliminarPrompt(), 50);
  }

  public async eliminarPrompt() {
    if (!this.idEliminarPrompt) { return; }
    await chatModule.eliminarPrompt(this.idEliminarPrompt);
    this.idEliminarPrompt = 0;
  }

  public async inicializarPrompts() {
    await chatModule.inicializarPrompts();
  }

  public confirmarVaciar() {
    this.dialogVaciar = true;
  }

  public async eliminarMemoria(id: number) {
    await chatModule.eliminarMemoria(id);
  }

  public async vaciarMemorias() {
    await chatModule.vaciarMemorias();
    this.dialogVaciar = false;
  }

  public async toggleDepartamento(id: number) {
    await chatModule.togglePrompt(id);
    await chatModule.getDepartamentos();
  }

  public async eliminarDepartamento(id: number) {
    await chatModule.eliminarDepartamento(id);
  }

  public async cargarConversaciones() {
    await chatModule.getConversaciones();
  }

  public async guardarConfig() {
    this.guardando = true;
    await chatModule.guardarConfig(this.configForm);
    this.guardando = false;
  }

  public async probarConexion() {
    this.probando = true;
    this.mensajePrueba = "";
    try {
      await ssmHttpService.post(API.chatIA + "chat", {
        ConversacionId: null,
        Mensaje: "Responde solo con 'OK'",
      }, false);
      this.tipoPrueba = "success";
      this.mensajePrueba = "✅ Conexión exitosa — el modelo respondió correctamente.";
    } catch (e) {
      this.tipoPrueba = "error";
      const msg = (e && (e as any).message) ? (e as any).message : String(e);
      this.mensajePrueba = "❌ " + msg;
    }
    this.probando = false;
  }
}
